import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTheme } from '../../context/ThemeContext';
import Topbar from './Topbar';
import Sidebar from './Sidebar';

export default function MainLayout({ children }) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const { B } = useTheme();
  const location = useLocation();

  const getPageLabel = () => {
    const path = location.pathname.slice(1);
    switch (path) {
      case 'timeclock': return 'Time Clock';
      case 'emar': return 'eMAR';
      case 'staff': return 'Staff & HR';
      case 'careplans': return 'Care Plans';
      case 'assessments': return 'Assessments';
      default: return path.charAt(0).toUpperCase() + path.slice(1) || 'Dashboard';
    }
  };

  useEffect(() => {
    if (isMobile) {
      setMobileMenuOpen(false);
    }
  }, [location.pathname, isMobile]);

  useEffect(() => {
    const handleResize = () => {
      const newIsMobile = window.innerWidth <= 768;
      setIsMobile(newIsMobile);
      if (!newIsMobile) {
        setMobileMenuOpen(false);
      }
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  return (
    <div style={{
      fontFamily: "'Poppins', sans-serif",
      background: B.bg,
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column'
    }}>
      <Topbar onMenuClick={toggleMobileMenu} />

      <div style={{ display: 'flex', flex: 1, position: 'relative' }}>
        {/* Mobile overlay */}
        {mobileMenuOpen && isMobile && (
          <div
            onClick={toggleMobileMenu}
            style={{
              position: 'fixed',
              inset: 0,
              background: 'rgba(0,0,0,0.5)',
              zIndex: 998
            }}
          />
        )}

        {/* Sidebar - Desktop always visible, Mobile slides in */}
        {(!isMobile || (isMobile && mobileMenuOpen)) && (
          <div style={{
            width: '220px',
            flexShrink: 0,
            ...(isMobile && {
              position: 'fixed',
              top: 0,
              left: 0,
              bottom: 0,
              zIndex: 999,
              transform: mobileMenuOpen ? 'translateX(0)' : 'translateX(-100%)',
              transition: 'transform 0.3s ease'
            })
          }}>
            <Sidebar onClose={() => setMobileMenuOpen(false)} />
          </div>
        )}

        {/* Main content */}
        <main style={{
          flex: 1,
          overflowX: 'auto',
          padding: '20px 24px',
          width: '100%'
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginBottom: 20,
            flexWrap: 'wrap',
            gap: 12
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <span style={{ fontSize: 12, color: B.muted, display: isMobile ? 'none' : 'inline' }}>Forward Care Hub</span>
              {!isMobile && <span style={{ fontSize: 12, color: B.muted }}>/</span>}
              <span style={{ fontSize: 12, fontWeight: 700, color: B.navy }}>{getPageLabel()}</span>
            </div>
            <div style={{ fontSize: 12, color: B.muted }}>
              {new Date().toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric', year: 'numeric' })}
            </div>
          </div>

          <div className="fade-in">{children}</div>
        </main>
      </div>
    </div>
  );
}